import React, { FC } from 'react';
import "./ToggleMode.scss";
import ToggleImage from "./Img/toggle_sprite.svg";
import ImageSprite from '../ImageSprite/ImageSprite';

interface IToggle {
    stateChecked: boolean;
    handleToggle: (isChecked: boolean) => void;
}

const ToggleMode: FC<IToggle> = (props) => {
    const { stateChecked, handleToggle } = props;
    const toggleHandler = () => {
        handleToggle(!stateChecked);
    };
    return (
        <>
            <input
                checked={stateChecked}
                onChange={toggleHandler}
                className={`toggle_checkbox toggle_checkbox__${stateChecked}`}
                id={`toggle_checkbox`}
                type="checkbox"
            />
            <label
                className="toggle"
                htmlFor={`toggle_checkbox`}
            >
                <div className="toggle_icon toggle_icon__black">
                    <ImageSprite iconSprite={`${ToggleImage}#black`} />
                </div>
                <div className="toggle_icon toggle_icon__light">
                    <ImageSprite iconSprite={`${ToggleImage}#light`} />
                </div>
                <span className={`toggle_switch`} />
            </label>
        </>
    );
};

export default ToggleMode;
